import {API, getApiPath} from '@/lib/utils/api.utils';
import {isError} from '@epic-mw/error-types';
import useSWRImmutable from 'swr/immutable';

interface AppInfo {
	name: string;
	version: string;
}

export const getAppInfo = async (): Promise<AppInfo> => {
	try {
		const response = await API<AppInfo>(`${getApiPath()}/version`, {
			headers: {'Cache-Control': 'no-store, no-cache', Expires: '0'}
		});
		return response?.data;
	} catch (err) {
		console.error('auth() failed to load', isError(err) && err.message);
		throw err;
	}
};

export const useAppInfo = () => {
	const {data, error} = useSWRImmutable('/api/version', getAppInfo, {
		errorRetryCount: 1
	});
	return {data, isLoading: !data && !error, error};
};
